<template>
    <div
        :class="`formulate-input-element formulate-input-element--${context.class}`"
        :data-type="context.type"
    >
        <b-form-textarea
            ref="textareaComponent"
            v-model="context.model"
            v-bind="context.attributes"
            @blur="context.blurHandler"
        ></b-form-textarea>  
        <!-- rows="3"
            max-rows="6" -->
        <div v-if="snippetArea" class="mt-1">
            <div class="">
                <b-button variant="minimal-primary" size="sm" @click="showSnippetModal">
                    <b-icon icon="file-text" class="mr-1"></b-icon>
                    <span class="special-text">{{ snippetButtonText }}</span>
                </b-button>
            </div>
            <b-modal
                title="Insert a snippet..."
                centered
                size="lg"
                ref="snippetModal"
                v-model="snippetModalShowing"
                body-class="p-0"
                hide-footer
            >
                <snippet-manager
                    :areaSlug="snippetArea"
                    mode="insert"
                    @insert="handleSnippetInsert"
                ></snippet-manager>
            </b-modal>
        </div>
        
    </div>
</template>

<script>
import SnippetManager from '../snippets/SnippetManager.vue';

// uses BootstrapVue textarea, but this is a custom Formulate input

export default {
    name: 'FormulateSnippetTextarea',
    components: {
        SnippetManager,
    },
    mixins: [],
    props: {
        context: {  // standard Formulate input context 
            type: Object,
            required: true
        },
        snippetArea: {
            type: String,
            required: false,  // if not provided, then no snippets
        },
        snippetButtonText: {
            type: String,
            default: 'Insert Saved Snippet',
        }
        // all other props, just pass them on to textarea in context.attributes
    },
    data() {
        return {
            // SNIPPETS
            insertSnippetPosition: 0,  // index/position in the textarea where we insert... we capture it when user clicks to insert snippet
            snippetModalShowing: false,  // v-model with the modal
        }
    },
    computed: {

    },
    mounted() {
        
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage

        // SNIPPETS
        getTextareaComponent() {
            // get the BS-Vue textarea component - used in a couple places, just a helper for that
            // returns undefined if can't find it (maybe not in the right mode)
            // returns the b-form-textarea component (or undefined)
            return this.$refs['textareaComponent'];
        },
        showSnippetModal() {
            // we will also record the current cursor position in the textarea so we know where to insert
            // we do this before it loses focus
            // have to traverse refs for now... to our HotEditTextarea, then to its ref on the BFormTextarea, then get .selectionEnd property from that
            const textarea = this.getTextareaComponent();
            this.insertSnippetPosition = textarea ? textarea.selectionEnd : 0;
            this.snippetModalShowing = true;
        },
        handleSnippetInsert(content) {
            // get the textarea, insert content at our stashed position
            // we use setRangeText(replacement, start) - that is native JS way to insert text (focus it first)
            // but the BS-Vue textarea also implements it, so call it on the BS-Vue textarea component
            console.log('insert this content at position', this.insertSnippetPosition, content);
            const textarea = this.getTextareaComponent();
            if (!textarea) {
                console.error('Cannot find textarea to insert the snippet!');
                return;
            }
            textarea.focus();
            textarea.setRangeText(content);  // the bs-vue implementation doesn't seem to support args of (content, startPosition)
            // just setting the text does not trigger Formulate to update... so we need to do it manually...
            const newValue = textarea.$el.value;  // that will have the new text
            this.context.model = newValue;  // that will update Formulate, and update the textarea
            // done, now close modal
            this.snippetModalShowing = false;
        },
    }
}
</script>

<style>

</style>